import { type Component, createSignal, Show } from "solid-js";
import { Portal } from "solid-js/web";
import { LayoutSolidModalView } from "~/solidJs/entities/SolidModalView";
import { openPricingPage } from "~/solidJs/shared/models/pageParams/pricingPageParams";
import { Button, TrainPanelModal } from "~/solidJs/shared/ui";

type ModelsLimitModalWidgetProps = Record<string, never>;
export const [getIsModelsLimitModalVisible, setIsModelsLimitModalVisible] = createSignal(false);
export const ModelsLimitModalWidget: Component<ModelsLimitModalWidgetProps> = () => {
	return (
		<Show when={getIsModelsLimitModalVisible()}>
			<Portal mount={document.body}>
				<LayoutSolidModalView toggleSelf={setIsModelsLimitModalVisible}>
					<TrainPanelModal
						toggleSelf={setIsModelsLimitModalVisible}
						HeaderTitle={
							<h1>
								Due to your current price plan you have reached the limit for
								retaining models.
							</h1>
						}
						HeaderSubtitle={
							<p>
								Please, upgrade your subscribtion plan or remove other previous
								models to be able to use this one.{" "}
							</p>
						}
						Buttons={[
							<Button
								variant="premium"
								onClick={() => openPricingPage({ source: "modelsLimitModal" })}
							>
								Upgrade my plan
							</Button>
						]}
					/>
				</LayoutSolidModalView>
			</Portal>
		</Show>
	);
};
